import { initialApplicationState } from '@/application'

export default {
  application: state => state.application,
  initialApplication: () => initialApplicationState()
}
